module.exports = __webpack_public_path__ + "static/media/battery-level-50-charging.6368eccc.svg";